import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SalesPlanImageService implements OnDestroy {
  private readonly imageUrlCache = new Map<string, Observable<string | null>>();
  private readonly objectUrls: string[] = [];

  constructor(private httpClient: HttpClient) { }

  getImageUrl(salesPlanId: number, imageId: number, fileIndex: number): Observable<string | null> {
    const cacheKey = `${salesPlanId}_${imageId}_${fileIndex}`;
    const cachedImageUrl = this.imageUrlCache.get(cacheKey);

    if (cachedImageUrl) {
      return cachedImageUrl;
    }

    const url = `${environment.gateway_url}/getsalesplanimage/${salesPlanId}/${imageId}/${fileIndex}`;
    const imageUrl = this.httpClient.get(url, { responseType: 'blob' }).pipe(
      map((blob: Blob) => {
        const objectUrl = URL.createObjectURL(blob);
        this.objectUrls.push(objectUrl);
        return objectUrl;
      }),
      catchError(() => of(null)),
      shareReplay(1)
    );

    this.imageUrlCache.set(cacheKey, imageUrl);
    return imageUrl;
  }

  clearCache(): void {
    this.objectUrls.forEach(objectUrl => URL.revokeObjectURL(objectUrl));
    this.objectUrls.length = 0;
    this.imageUrlCache.clear();
  }

  ngOnDestroy(): void {
    this.clearCache();
  }
}
